export default __webpack_public_path__ + "static/study-febrile-small-79e7148a0702d03405d33b177f193161.svg";